import type {
  GetElecAnalysisMarketMonitoringAllMarketsChartParams,
  GetElecAnalysisMarketMonitoringAllMarketsChartResponse,
  GetElecAnalysisMarketMonitoringAllMarketsDailyResponse,
  GetElecAnalysisMarketMonitoringBandsChartParams,
  GetElecAnalysisMarketMonitoringBandsChartResponse,
  GetElecAnalysisMarketMonitoringBasePeakDifferenceChartParams,
  GetElecAnalysisMarketMonitoringBasePeakDifferenceChartResponse,
  GetElecAnalysisMarketMonitoringBasePeakDifferenceDailyResponse,
  GetElecAnalysisMarketMonitoringBasePeakYearlyDifferenceChartParams,
  GetElecAnalysisMarketMonitoringBasePeakYearlyDifferenceChartResponse,
  GetElecAnalysisMarketMonitoringBasePeakYearlyDifferenceIndicatorsResponse,
  GetElecAnalysisMarketMonitoringFutureProdChartParams,
  GetElecAnalysisMarketMonitoringFutureProdChartResponse,
  ElecAnalysisDateRangePriodParams,
  GetElecAnalysisMarketMonitoringFutureProdComparisonTableResponse,
  GetElecAnalysisMarketMonitoringFutureProdDailyResponse,
  GetElecAnalysisMarketMonitoringIndicatorsParams,
  GetElecAnalysisMarketMonitoringIndicatorsResponse,
  GetElecAnalysisMarketMonitoringSpotAvgChartParams,
  GetElecAnalysisMarketMonitoringSpotAvgChartResponse,
  GetElecAnalysisMarketMonitoringTreeChartParams,
  GetElecAnalysisMarketMonitoringTreeChartResponse,
  GetElecAnalysisMarketMonitoringBasePeakDifferenceComparisonTableResponse,
  GetElecAnalysisMarketMonitoringBasePeakYearlyDifferenceTableResponse,
  GetElecAnalysisMarketMonitoringAllMarketsTableResponse,
  BarChartDataType,
  GetElecAnalysisAverageHourlyPricingParams,
  GetElecAnalysisAverageHourlyPricingResponse,
  GetElecAnalysisAnnualComparisonForHourlyProductsResponse,
  GetElecAnalysisAnnualComparisonForHourlyProductsParams,
} from "$/lib/types/api/market-monitoring/electricity-analysis.types";
import { restApiClient } from "../restApiClient";

export const getElecAnalysisTreeChart = async (
  params: GetElecAnalysisMarketMonitoringTreeChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/tree-chart")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringTreeChartResponse>();
};

export const getElecAnalysisFutureProductsChart = async (
  params: GetElecAnalysisMarketMonitoringFutureProdChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/future-products-chart")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringFutureProdChartResponse>();
};

export const getElecAnalysisFutureProdDaily = async (params: {
  date: string;
}) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/future-products-daily")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringFutureProdDailyResponse>();
};

export const getElecAnalysisFutureProdComparisonTable = async (
  params: ElecAnalysisDateRangePriodParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/future-products-comparison-table")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringFutureProdComparisonTableResponse>();
};

export const getElecBandsChart = async (
  params: GetElecAnalysisMarketMonitoringBandsChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/bands-chart")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringBandsChartResponse>();
};

export const getElecBasePeakDifferenceChart = async (
  params: GetElecAnalysisMarketMonitoringBasePeakDifferenceChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/base-peak-difference-chart")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringBasePeakDifferenceChartResponse>();
};

export const getElecBasePeakDifferenceDaily = async (params: {
  date: string;
}) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/base-peak-difference-daily")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringBasePeakDifferenceDailyResponse>();
};

export const getElecBasePeakDifferenceComparisonTable = async (
  params: ElecAnalysisDateRangePriodParams,
) => {
  return restApiClient
    .url(
      "/market-monitoring/elec-analysis/base-peak-difference-comparison-table",
    )
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringBasePeakDifferenceComparisonTableResponse>();
};

export const getElecBasePeakYearlyDifferenceChart = async (
  params: GetElecAnalysisMarketMonitoringBasePeakYearlyDifferenceChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/base-peak-yearly-difference-chart")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringBasePeakYearlyDifferenceChartResponse>();
};

export const getElecBasePeakYearlyDifferenceDailyIndicators = async (params: {
  date: string;
}) => {
  return restApiClient
    .url(
      "/market-monitoring/elec-analysis/base-peak-yearly-difference-indicators",
    )
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringBasePeakYearlyDifferenceIndicatorsResponse>();
};

export const getElecBasePeakYearlyDifferenceComparisonTable = async (
  params: ElecAnalysisDateRangePriodParams,
) => {
  return restApiClient
    .url(
      "/market-monitoring/elec-analysis/base-peak-yearly-difference-comparison-table",
    )
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringBasePeakYearlyDifferenceTableResponse>();
};

export const getElecAllMarketsChart = async (
  params: GetElecAnalysisMarketMonitoringAllMarketsChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/all-markets-chart")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringAllMarketsChartResponse>();
};

export const getElecAllMarketsDaily = async (params: { date: string }) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/all-markets-daily")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringAllMarketsDailyResponse>();
};

export const getElecAllMarketComparisonTable = async (
  params: ElecAnalysisDateRangePriodParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/all-markets-comparison-table")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringAllMarketsTableResponse>();
};

export const getElecAnalysisSpotAvgChart = async (
  params: GetElecAnalysisMarketMonitoringSpotAvgChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/spot-price-chart")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringSpotAvgChartResponse>();
};

export const getElecAnalysisIndicators = async (
  params: GetElecAnalysisMarketMonitoringIndicatorsParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/indicators")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringIndicatorsResponse>();
};

export const getElecRSIChart = async (
  params: GetElecAnalysisMarketMonitoringBandsChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/rsi-chart")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringBandsChartResponse>();
};

// Bar charts

export const getElecSpotAvgYearly = async () => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/elec-spot-avg-yearly")
    .get<BarChartDataType[]>();
};

export const getElecAvgYearly = async () => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/elec-avg-yearly")
    .get<BarChartDataType[]>();
};

//

export const getAverageHourlyPricing = async (
  params: GetElecAnalysisAverageHourlyPricingParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/average-hourly-pricing")
    .query({ ...params })
    .get<GetElecAnalysisAverageHourlyPricingResponse>();
};

export const getAnnualComparisonForHourlyProducts = async (
  params: GetElecAnalysisAnnualComparisonForHourlyProductsParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec-analysis/hourly-products-hourly-comparison")
    .query({ ...params })
    .get<GetElecAnalysisAnnualComparisonForHourlyProductsResponse>();
};
